// FIXME: https://github.com/import-js/eslint-plugin-import/pull/2716
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React, { Fragment } from 'react';
import { Box } from 'braid-design-system';

const Layout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <Fragment>
    <Box display="flex" flexDirection="row" justifyContent="center">
      <Box padding="large" style={{ width: '794px' }}>
        {children}
      </Box>
    </Box>
  </Fragment>
);

export default Layout;
